import {Injectable} from '@angular/core';
declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class ConfettiService {

  maxParticleCount: number = 150; //set max confetti count
  particleSpeed: number = 2; //set the particle animation speed
  startConfetti: boolean = false;
  colors = ["#27D07C", "#59CBE8", "#E68699", "#307FE2",]
  streamingConfetti: boolean = false;
  animationTimer: number = null;
  particles = [];
  waveAngle = 0;
  text: string = "";

  constructor() {
  }

  resetParticle(particle, width, height) {
    particle.color = this.colors[(Math.random() * this.colors.length) | 0];
    particle.x = Math.random() * width;
    particle.y = Math.random() * height - height;
    particle.diameter = Math.random() * 10 + 5;
    particle.tilt = Math.random() * 10 - 10;
    particle.tiltAngleIncrement = Math.random() * 0.07 + 0.05;
    particle.tiltAngle = 0;
    return particle;
  }

  setConfettiText(text: string){
    this.text = text;
  }

  startConfettiInner() {
    let width = window.innerWidth - 20;
    let height = window.innerHeight;
    window.requestAnimFrame = (function () {
      return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
          return window.setTimeout(callback, 16.6666667);
        };
    })();
    let canvas = <HTMLCanvasElement>document.getElementById("confetti-canvas");
    if (canvas === null) {
      canvas = document.createElement("canvas");
      canvas.setAttribute("id", "confetti-canvas");
      canvas.setAttribute("class", "confetti-canvas");
      document.body.appendChild(canvas);
      canvas.width = width;
      canvas.height = height;
      window.addEventListener("resize", () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }, true);
      let div = document.getElementById("congrats-text");
      if(div === null){
        div = document.createElement("div");
        div.setAttribute("id", "congrats-text");
        div.className = "confetti-text";
        document.body.appendChild(div);
      }
      div.innerHTML = this.text;
    }
    let context = canvas.getContext("2d");
    while (this.particles.length < this.maxParticleCount)
      this.particles.push(this.resetParticle({}, width, height));
    this.streamingConfetti = true;
    if (this.animationTimer === null) {
      let runAnimation = () => {
        context.clearRect(0, 0, window.innerWidth, window.innerHeight);
        if (this.particles.length === 0)
          this.animationTimer = null;
        else {
          this.updateParticles();
          this.drawParticles(context);
          this.animationTimer = window.requestAnimFrame(runAnimation);
        }
      };
      runAnimation();
    }
  }

  stopConfettiInner() {
    this.streamingConfetti = false;
    setTimeout(()=>{
      document.getElementById("congrats-text").remove();
      document.getElementById("confetti-canvas").remove();
    }, 3000);
  }

  toggleConfettiInner() {
    if (this.streamingConfetti)
      this.stopConfettiInner();
    else
      this.startConfettiInner();
  }

  drawParticles(context) {
    let particle;
    let x;
    for (let i = 0; i < this.particles.length; i++) {
      particle = this.particles[i];
      context.beginPath();
      context.lineWidth = particle.diameter;
      context.strokeStyle = particle.color;
      x = particle.x + particle.tilt;
      context.moveTo(x + particle.diameter / 2, particle.y);
      context.lineTo(x, particle.y + particle.tilt + particle.diameter / 2);
      context.stroke();
    }
  }

  updateParticles() {
    let width = window.innerWidth;
    let height = window.innerHeight;
    let particle;
    this.waveAngle += 0.01;
    for (let i = 0; i < this.particles.length; i++) {
      particle = this.particles[i];
      if (!this.streamingConfetti && particle.y < -15)
        particle.y = height + 100;
      else {
        particle.tiltAngle += particle.tiltAngleIncrement;
        particle.x += Math.sin(this.waveAngle);
        particle.y += (Math.cos(this.waveAngle) + particle.diameter + this.particleSpeed) * 0.5;
        particle.tilt = Math.sin(particle.tiltAngle) * 15;
      }
      if (particle.x > width + 20 || particle.x < -20 || particle.y > height) {
        if (this.streamingConfetti && this.particles.length <= this.maxParticleCount)
          this.resetParticle(particle, width, height);
        else {
          this.particles.splice(i, 1);
          i--;
        }
      }
    }
  }
}
